"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _getDates = require("../../../../utils/getDates");
var _rowConfig = _interopRequireDefault(require("../../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../../core/form-group"));
var _label = _interopRequireDefault(require("../../../core/label"));
var _col = _interopRequireDefault(require("../../../core/col"));
var _inputOnBlur = _interopRequireDefault(require("../../../core/input-on-blur"));
var _row = _interopRequireDefault(require("../../../core/row"));
var _alert = _interopRequireDefault(require("../../../core/alert"));
var _modal = _interopRequireDefault(require("../../../core/modal"));
var _button = _interopRequireDefault(require("../../../core/button"));
var _fullWidth = _interopRequireDefault(require("../../../root/full-width"));
var _coreApplication = _interopRequireDefault(require("../shared-components/core-application"));
var _contactDetails = _interopRequireDefault(require("../shared-components/contact-details"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  changingAcceptedApplication: false,
  errorMessage: null,
  field: null,
  value: null
};
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "You do not have access to this application");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "WARNING Changing this initial application data will reset the status of your application to applied for.");
var _ref3 = /*#__PURE__*/_react.default.createElement("p", null, "Please click Confirm to continue.");
var _ref4 = /*#__PURE__*/_react.default.createElement("div", {
  className: "card-header"
}, /*#__PURE__*/_react.default.createElement("h5", null, "Core Application"));
var _ref5 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Start Date*");
var _ref6 = /*#__PURE__*/_react.default.createElement("div", {
  className: "card-header"
}, /*#__PURE__*/_react.default.createElement("h5", null, "Contact Information"));
class ApplicationChange extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_validateDate", value => {
      if (!value) return 'Start date required';
      const calendarDates = this.props.calendar.calendarDates.map(d => d.id);
      if (!calendarDates.includes(value)) return 'Date not in the calendar';
      const invalidDates = (0, _getDates.getDates)(value, this.props.applicationByID.numberOfDays).filter(d => !calendarDates.includes(d));
      if (invalidDates.length) return invalidDates.map(d => (0, _occasion.default)(d, 'dddd DD MMMM')).join(', ') + ' not available in calendar';
    });
    _defineProperty(this, "_setValue", (value, field) => {
      switch (field) {
        case 'siteID':
          if (this.props.applicationByID.applicationStatusRef !== 'APPY') return this.setState({
            changingAcceptedApplication: true,
            value,
            field
          });
          break;
        case 'numberOfDays':
          // TODO - work out how to do this. Impacts racing.
          return this.setState({
            errorMessage: "Sorry, you cannot change this yet, I'm working on it!"
          });
        case 'calendarDateID':
          const result = this._validateDate(value);
          if (result) return this.setState({
            errorMessage: result
          });
          if (this.props.applicationByID.applicationStatusRef !== 'APPY') return this.setState({
            changingAcceptedApplication: true,
            value,
            field
          });
          break;
        default:
          break;
      }
      this.props.setValue(this.props.applicationByID.id, value, field);
    });
    _defineProperty(this, "_onConfirm", (value, field) => {
      this.props.setValue(this.props.applicationByID.id, value, field);
      this.setState(initialState);
    });
    _defineProperty(this, "_setSelected", (field, value) => {
      this._setValue(value, field);
    });
    _defineProperty(this, "_onCloseCancel", () => {
      this.setState(initialState);
    });
  }
  render() {
    const application = this.props.applicationByID;
    if (!application || !application.id) return null;
    if (!application.isAdministratedByUser) return _ref;
    if (application.calendarID !== +this.props.match.params.yearID) return /*#__PURE__*/_react.default.createElement("p", null, "There is no such application in ", this.props.match.params.yearID);
    return /*#__PURE__*/_react.default.createElement(_fullWidth.default, null, /*#__PURE__*/_react.default.createElement("div", null, !this.state.errorMessage ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      onClose: this._onCloseCancel,
      buttons: /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this._onCloseCancel,
        type: "primary"
      }, "Close")
    }, /*#__PURE__*/_react.default.createElement(_alert.default, {
      type: "danger"
    }, this.state.errorMessage)), !this.state.changingAcceptedApplication ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      onClose: this._onCloseCancel,
      buttons: /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this._onCloseCancel
      }, "Cancel"), /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: () => this._onConfirm(this.state.value, this.state.field),
        type: "primary"
      }, "Confirm Change"))
    }, _ref2, _ref3), /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      lg: 6
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, _ref4, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4
      }, {
        sm: 8
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref5, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "Date",
      value: application.calendarDateID,
      onChange: this._setValue,
      name: "calendarDateID",
      required: true,
      customValidation: value => this._validateDate(value)
    })))), /*#__PURE__*/_react.default.createElement(_coreApplication.default, {
      application: application,
      setValue: this._setValue,
      setSelected: this._setSelected
    })))), /*#__PURE__*/_react.default.createElement(_col.default, {
      lg: 6
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, _ref6, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement(_contactDetails.default, {
      application: application,
      setValue: this._setValue,
      setSelected: this._setSelected
    })))))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref7 = _mergeBqlQueries(_mergeBqlQueries({
  id: true,
  isAdministratedByUser: true,
  calendarID: true,
  applicationStatusRef: true,
  calendarDateID: true
}, _coreApplication.default.partialQueries.Application), _contactDetails.default.partialQueries.Application);
var _ref8 = {
  id: true,
  calendarDates: {
    id: true
  }
};
var _default = exports.default = (0, _reactBicycle.connect)(ApplicationChange, props => ({
  ["applicationByID(applicationID:" + JSON.stringify(+props.match.params.appid) + ")"]: _ref7,
  ["calendar(yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref8
}), (client, props) => ({
  setValue(id, value, field) {
    return client.update('Application.set', {
      id,
      value,
      field
    });
  }
}));